// extracted by mini-css-extract-plugin
export var animationAbsolute = "_17-q";
export var animationRelative = "_17-p";
export var backdropBlur = "_17-0";
export var detailLabelCell = "_17-12";
export var detailTable = "_17-11";
export var detailValueCell = "_17-13";
export var docIconBox = "_17-1d";
export var docIconBoxMd = "_17-1f";
export var docIconBoxSm = "_17-1e";
export var docTypeRow = "_17-16";
export var docTypeRowInner = "_17-17";
export var dropdownMatchDatePicker = "_17-3";
export var evidenceCardContent = "_17-1c";
export var fileUploadSpin = "_17-j";
export var gorgiasOpenButton = "_17-15 _17-d";
export var gorgiasTicketCard = "_17-14";
export var heroModalFooterButton = "_17-18";
export var hiddenContainer = "_17-o";
export var iconPrimary = "_17-1g";
export var iconQuaternary = "_17-1i";
export var iconTertiary = "_17-1h";
export var integrationCard = "_17-1";
export var integrationLogoBox = "_17-2";
export var mainColumnSticky = "_17-1b";
export var maxWidthContainer = "_17-19";
export var modalContentBody = "_17-a";
export var modalHeaderImage = "_17-5";
export var modalImageLabel = "_17-7";
export var modalImageOverlay = "_17-6";
export var modalImageSubtitle = "_17-9";
export var modalImageTitle = "_17-8";
export var modalImageWrapper = "_17-4";
export var modalStickyFooter = "_17-b";
export var removeButton = "_17-e";
export var sidebarColumn = "_17-1a";
export var spinner = "_17-i";
export var timelineLine = "_17-y";
export var timelineLineBlack = "_17-10 _17-y";
export var timelineLineGray = "_17-z _17-y";
export var timelineLineHeight = "_17-x";
export var tlDotActivate = "_17-u";
export var tlDotActivateAnim = "_17-t";
export var tlDotHide = "_17-s";
export var tlDotHideAnim = "_17-r";
export var tlLineActivate = "_17-w";
export var tlLineActivateAnim = "_17-v";
export var uploadHint = "_17-n";
export var uploadIconBox = "_17-k";
export var uploadLabel = "_17-m";
export var uploadText = "_17-l";
export var uploadZone = "_17-f";
export var uploadZoneCursorDefault = "_17-h";
export var uploadZoneCursorPointer = "_17-g";
export var uploadedFileRow = "_17-c";
export var viewButton = "_17-d";